import infoGreen from 'assets/images/account-page/info-green.svg';
import savesExportsIcon from 'assets/images/plan-saves-exports.svg';
import teamMemberIcon from 'assets/images/plan-team.svg';
import skipTracingIcon from 'assets/images/plan-skip-tracing.svg';
import classNames from "classnames";
import React, { useRef, useEffect } from "react";
import css from "../style.scss";
import numberFormat from 'utils/number/format';
import { useDispatch, useSelector } from 'react-redux';
import { selectPlanDetails, updateSelectedChooseTierTooltip } from '../../../../data/user';

const MonthlyEssentialsIncludes = ({ selectedPlanOption }) => {
    const dispatch = useDispatch();
    const planDetails = useSelector(selectPlanDetails)?.toJS();
    const containerRef = useRef(null);

    const handleTooltipToggle = (tooltipId) => {
        const tooltipComponentId = `monthlyEssentials-${tooltipId}`;
        dispatch(updateSelectedChooseTierTooltip(tooltipComponentId));
    };

    useEffect(() => {
        return () => {
            dispatch(updateSelectedChooseTierTooltip(""));
        };
    }, []);

    return (
        <div className={css.clsInfoPopup} ref={containerRef}>
            <li>
                <img src={savesExportsIcon} className={css.clsIncludesIcon} alt="Monthly Saves & Exports" />
                <b>{numberFormat(selectedPlanOption)} </b>
                {" "}
                Monthly Saves & Exports
                <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('saves')}>
                    <img src={infoGreen} alt="info" />
                </span>
                <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupLeft, {
                    [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyEssentials-saves',
                })} style={selectedPlanOption < 100000 ? { left: '83%' } : { left: "-1%", bottom: "89%" }}>
                    <h6 className={css.clsInfoContentTitle}>Saves & Exports <span className={css.clsCloseIcon} onClick={() => handleTooltipToggle('')}>&times;</span></h6>
                    <p className={css.clsInfoContentPara}>PropStream makes it easy to save, export, and organize your real estate leads for effective marketing and outreach. Quickly export your leads to use with other tools and keep your records up to date. Additional saves and exports are available for purchase.</p>
                </div>
            </li>
            <li>
                <img src={teamMemberIcon} className={css.clsIncludesIcon} alt="Additional Team Members Available" />
                Additional Team Members Available
                <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('team')}>
                    <img src={infoGreen} alt="info" />
                </span>
                <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupLeft, {
                    [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyEssentials-team',
                })} style={{ left: '-1%', bottom: selectedPlanOption < 100000 ? '62%' : '56%'}}>
                    <h6 className={css.clsInfoContentTitle}>Team Members <span className={css.clsCloseIcon} onClick={() => handleTooltipToggle('')}>&times;</span></h6>
                    <p className={css.clsInfoContentPara}>Our Essentials plan is perfect for solo entrepreneurs. As your team grows, upgrade to Pro (2 team members included) or Elite (9 team members). Collaborate seamlessly and reach your goals faster!</p>
                </div>
            </li>
            <li>
                <img src={skipTracingIcon} className={css.clsIncludesIcon} alt="Free Phone Numbers on Some Properties" />
                Free Phone Numbers on Some Properties - Purchase Additional Skip Tracing
                <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('tracing')}>
                    <img src={infoGreen} alt="info" />
                </span>
                <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupLeft, {
                    [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyEssentials-tracing',
                })} style={{ left: '31%', bottom: '11%' }}>
                    <h6 className={css.clsInfoContentTitle}>Skip Tracing <span className={css.clsCloseIcon} onClick={() => handleTooltipToggle('')}>&times;</span></h6>
                    <p className={css.clsInfoContentPara}>Skip Tracing is available to main account holder and helps you uncover phone numbers and emails for your leads, giving you the tools to connect directly and efficiently. Say goodbye to dead ends and hello to new opportunities.</p>
                </div>
            </li>
        </div>
    )
}

export default MonthlyEssentialsIncludes;
